import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { tv } from "tailwind-variants";
import { containedCompoundVariants, outlinedCompoundVariants, surfaceCompoundVariants, textVariants, variantVariants } from "../../theme/variants/sharedVariants";
import cn from "../../utils/cn";
const tagVariants = tv({
    base: "items-center flex whitespace-nowrap justify-center h-fit rounded-2xl w-fit bg-white text-xs font-medium ",
    variants: {
        size: {
            condensed: "px-2.5 h-6", // TODO: remove this when change on dashboard
            default: "px-2.5 h-8 ", // TODO: remove this when change on dashboard
            sm: "px-2.5 h-6",
            md: "px-2.5  h-8",
        },
        color: textVariants,
        type: {
            square: "rounded-md p-2",
            rounded: "rounded-2xl",
        },
        variant: variantVariants,
    },
    compoundVariants: [...containedCompoundVariants, ...outlinedCompoundVariants, ...surfaceCompoundVariants],
    defaultVariants: {
        color: "default",
        size: "sm",
        variant: "default",
        type: "rounded",
    },
});
const customIcon = (icon, color, variant) => {
    return React.cloneElement(icon, {
        className: cn(variant === "default" && {
            "text-gray-dark": color === "default",
            "text-primary": color === "primary",
            "text-success": color === "success",
            "text-danger": color === "danger",
            "text-warning": color === "warning",
            "text-danger-dark": color === "danger-dark",
            "text-attention-11": color === "attention",
            "text-accessory-purple-11": color === "purple",
            "text-accessory-sky-11": color === "sky",
        }),
    });
};
const Tag = ({ className, variant, color, label, type, icon, size, ...props }) => {
    return (_jsx("div", { className: cn(tagVariants({ variant, color, type, size }), className), ...props, children: _jsxs("div", { className: "flex items-center gap-2 leading-100", children: [icon ? customIcon(icon, color, variant) : null, label] }) }));
};
Tag.displayName = "Tag";
export default Tag;
